import './menuUsers.scss';
import $ from 'jquery';

$(function() {

    //MENU SECONDAIRE, sous-menu qui s'ouvre en accordéon
    //$('.menu-menu-secondaire-container #user-menu>li.menu-item-has-children>ul li.current-menu-item').parent().show().prev().addClass('active');


    // ARIA + active class
    $('.menu-menu-secondaire-container #user-menu li .sub-menu').attr('aria-label','Sous-menu');
    $('.menu-menu-secondaire-container #user-menu li.current-menu-ancestor').removeClass('active');
    $('.menu-menu-secondaire-container #user-menu .menu-item-has-children>a').attr('aria-haspopup','true');
    $('.menu-menu-secondaire-container #user-menu li.menu-item-has-children').click(function(e){
        $(this).children('ul').click(function(){
           // alert("child event is triggered");
            e.stopPropagation();
            e.preventDefault();
        });

        if($(this).hasClass('active')){
            $(this).removeClass('active');
            $(this).parent().removeClass('active');
            $('.menu-menu-secondaire-container #user-menu .menu-item-has-children>a').removeClass('show');
            $(this).children('ul').stop().slideUp();
            return;
        } else {
            $(this).addClass('active');
            $('.menu-menu-secondaire-container #user-menu .menu-item-has-children>a').addClass('show');
            $(this).parent().addClass('active');
            $(this).children('ul').stop().slideDown();
            return;
        }
    })




   /* if($('.menu-menu-secondaire-container #user-menu li.menu-item-has-children .sub-menu li.menu-item').hasClass('current_page_item')){
        $('.menu-menu-secondaire-container #user-menu .menu-item-has-children>a').addClass('show');
    } else {
        $('.menu-menu-secondaire-container #user-menu .menu-item-has-children>a').removeClass('show');
    }*/







});